import { Injectable } from '@angular/core';
import { RevalidatedHttpService, RevalidatedResource } from 'src/app/core/http-cache/revalidated-http.service';
import { HttpClient, HttpHeaders, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Custompage } from './../models/custompage';
import { Observable, throwError } from 'rxjs'; import { SanctumService } from 'src/app/services/sanctum.service';
import { environment } from 'src/environments/environment';
import { map, startWith, switchMap } from 'rxjs/operators';
import { retry, catchError } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { LocalstorageService } from 'src/app/services/localstorage.service';
import { of, from } from 'rxjs'; import { AuthHeaderService } from 'src/app/services/auth-header.service';
import { Store } from 'src/app/models/store';
interface Config {
  id: number;
  store_id: number;
  category: number;
  key: string;
  value: string;
  created_at: string;
  updated_at: string;
}
@Injectable({
  providedIn: 'root'
})
export class ConfGeraisService {
  // Base url
  baseurl = '';

  constructor(
    private httpClient: HttpClient,
    private http: HttpClient,
    private authHeaderService: AuthHeaderService,
    private auth: AuthService,
    private localstorageService: LocalstorageService,
    private sanctum: SanctumService,
    private revalidatedHttp: RevalidatedHttpService
  ) {

    this.baseurl = `${environment.serverUrl}/admin`;
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
  }
  public getDadosLoja(): Observable<any[]> {
    const lojas = this.getUser().stores;
    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    // Atualiza id_loja com o último store_id do array, se houver
    lojas.forEach((item: any) => {
      id_loja = item.store_id;
    });

    const body = {};

    const baseUrl = `${environment.apiBaseUrl}/api`;
    const url = `${baseUrl}/public/admin/show_stores`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getPublicHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.post<any[]>(url, body, httpOptions).pipe(
              catchError(this.errorHandl)
            )
          )
        )
      )
    );
  }


  public getDadosLojaPorId(): Observable<Store[]> {
    const id_loja = localStorage.getItem('ss_SelectedStoreId') || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/public/admin/show_stores?store_id=${encodeURIComponent(id_loja)}`;

    return from(this.authHeaderService.getPublicHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<Store[]>(url, httpOptions).pipe(
          catchError((error) => {
            console.error('Erro ao buscar dados da loja por ID:', error);
            return throwError(() => error);
          })
        )
      )
    );
  }

  // Cache-first com ETag (src/app/core/http-cache).
  public getDadosLojaPorIdRevalidated(): RevalidatedResource<Store[]> {
    const id_loja = localStorage.getItem('ss_SelectedStoreId') || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/public/admin/show_stores?store_id=${encodeURIComponent(id_loja)}`;
    const cacheKey = `dados_loja:store:${id_loja}`;

    return this.revalidatedHttp.getSignal<Store[]>(
      cacheKey,
      url,
      this.authHeaderService.getPublicHttpOptions()
    );
  }


  verificarDisponibilidadeSubdominio(subdomain: any): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/shop/store/verify?subdomain=${encodeURIComponent(subdomain)}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<any>(url, httpOptions)
      )
    );
  }

  verificarDisponibilidadeEmail(email: any): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/verify?email=${encodeURIComponent(email)}`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.http.get<any>(url, httpOptions)
      )
    );
  }

  createOnboarding(data: any): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/onboarding`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.post<any>(url, data, httpOptions)
          )
        )
      )
    );
  }


  insertNewEmail(data: any, user_id: number | undefined): Observable<any> {
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/users/email_public/${user_id}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.http.patch<any>(url, data, httpOptions)
          )
        )
      )
    );
  }



  createDNSRecord(data: any): Observable<any> {
    this.httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${this.getAccessToken()}`
      }),
    };
    if (environment.production) {
      return this.http.post('https://api.cloudflare.com/client/v4/zones/{zone_id}/dns_records', data, this.httpOptions);
    } else {
      return this.http.post('https://api.cloudflare.com/client/v4/zones/{zone_id}/dns_records', data, this.httpOptions);
    }
  }

  public getConfigsLojaPorId(): Observable<Config[]> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/settings`;

    return from(this.authHeaderService.getHttpOptions()).pipe(
      switchMap(httpOptions =>
        this.httpClient.get<Config[]>(url, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  // Cache-first com ETag.
  public getConfigsLojaPorIdRevalidated(): RevalidatedResource<Config[]> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/settings`;
    const cacheKey = `store_settings:store:${id_loja}`;

    return this.revalidatedHttp.getSignal<Config[]>(
      cacheKey,
      url,
      this.authHeaderService.getHttpOptions()
    );
  }


  updateDadosLoja(data: any): Observable<Store> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.patch<Store>(url, data, httpOptions)
          )
        )
      )
    );
  }

  updateDadosLojaConfig(data: any): Observable<Store> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/settings/configs`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() => this.authHeaderService.getHttpOptions()),
      switchMap(httpOptions =>
        this.httpClient.patch<Store>(url, data, httpOptions)
      ),
      catchError(error => throwError(() => error))
    );
  }

  updateUrlLoja(data: any): Observable<Store> {
    const id_loja = localStorage.getItem("ss_SelectedStoreId") || '';

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store/${id_loja}/subdomain`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.patch<Store>(url, data, httpOptions)
          )
        )
      )
    );
  }

  detalharInfosLoja(data: any): Observable<any> {
    console.log('chamou 1');

    const baseUrl = `${environment.apiBaseUrl}/api`;

    const url = `${baseUrl}/admin/store`;

    return from(this.sanctum.initSanctum()).pipe(
      switchMap(() =>
        from(this.authHeaderService.getHttpOptions()).pipe(
          switchMap(httpOptions =>
            this.httpClient.post<any>(url, data, httpOptions)
          )
        )
      )
    );
  }

  checkCEP(cep: any): Observable<any> {

    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    if (environment.production) {
      return this.httpClient.get<any>(`https://ws.hubdodesenvolvedor.com.br/v2/cep3/?cep=${cep}&token=116390195hnbTeuwZkO210138968`, this.httpOptions);
    } else {
      return this.httpClient.get<any>(`https://ws.hubdodesenvolvedor.com.br/v2/cep3/?cep=${cep}&token=116390195hnbTeuwZkO210138968`, this.httpOptions);
    }
  }

  checkCEP2(cep: any): Observable<any> {

    let id_loja = localStorage.getItem("ss_SelectedStoreId") || '';
    if (environment.production) {
      return this.httpClient.get<any>(`https://viacep.com.br/ws/${cep}/json/`, this.httpOptions);
    } else {
      return this.httpClient.get<any>(`https://viacep.com.br/ws/${cep}/json/`, this.httpOptions);
    }
  }

  // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${this.getAccessToken()}`
    }),
  };


  // Error handling
  errorHandl(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(() => {
      return errorMessage;
    });
  }

  private handleError2<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      console.error(error);
      this.log(`${operation} failed: ${error.message}`);

      return of(result as T);
    };
  }

  private log(message: string) {
    console.log(message);
  }


  getAccessToken(): string {
    return localStorage.getItem("access_token") || '';
  }

  getUser(): any {
    return JSON.parse(localStorage.getItem("user") || '');
  }

}
